import { inject, Injectable } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CartStoreRefiner } from '@common/refiners/cart.refiner';
import { OrderStoreSelector } from '@common/selectors/order.selector';
import { ErrorService } from '@core/services/error-service/error.service';

import {
  CartVoucherBlockDataSource,
  CartVoucherBlockViewModel,
} from './cart-voucher-block-view-model';

@Injectable()
export class CartVoucherBlockStoreDataSource implements CartVoucherBlockDataSource {
  private readonly orderSelector = inject(OrderStoreSelector);
  private readonly cartRefiner = inject(CartStoreRefiner);
  private readonly errorService = inject(ErrorService);

  readonly vm$: Observable<CartVoucherBlockViewModel> = combineLatest([
    this.orderSelector.selectValidation$,
    this.cartRefiner.selectActiveCartCoupon,
    this.errorService.getErrorMessage$().pipe(map(message => message.length)),
  ]).pipe(
    map(([validation, coupon, errorLength]) => ({
      isVisible: !!validation || (!!coupon && !!errorLength),
    })),
  );
}
